import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useSearchParams } from "react-router-dom";
import { Star, Search } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import api, { apiError } from "@/lib/api";

export default function CustomersTab() {
  const [params] = useSearchParams();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState(params.get("q") || "");
  const load = async () => { const { data } = await api.get("/admin/customers", { params: { q } }); setItems(data); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [q]);
  const requestReview = async (c) => {
    try { await api.post("/admin/customers/request-review", { customer_email: c.email, customer_name: c.name }); toast.success(`Review request sent to ${c.email}`); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Customers</h1>
        <p className="text-sm text-muted-foreground mt-1">{items.length} customers registered.</p>
      </div>
      <Card className="p-3 relative">
        <Search className="h-4 w-4 absolute left-6 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, email, phone…" className="pl-10" data-testid="customers-search" />
      </Card>
      {items.length === 0 ? (
        <Card className="p-16 text-center text-muted-foreground">No customers.</Card>
      ) : (
        <Card className="overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-secondary text-left text-xs uppercase tracking-wider text-muted-foreground"><tr>
              <th className="p-3">Name</th><th className="p-3">Email</th><th className="p-3">Phone</th><th className="p-3">Quotes</th><th className="p-3">Jobs</th><th className="p-3 text-right"></th>
            </tr></thead>
            <tbody>
              {items.map(c => (
                <tr key={c.user_id} className="border-t border-border">
                  <td className="p-3 font-medium">{c.name}</td>
                  <td className="p-3">{c.email}</td>
                  <td className="p-3">{c.phone || "—"}</td>
                  <td className="p-3">{c.quotes_count}</td>
                  <td className="p-3">{c.jobs_count}</td>
                  <td className="p-3 text-right"><Button size="sm" variant="ghost" onClick={() => requestReview(c)} data-testid={`review-btn-${c.user_id}`}><Star className="h-4 w-4 mr-1 text-eagle-gold" />Request review</Button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
}